// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__grdIK","footerText":"Footer_footerText__lR5Bc"};